<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    append-to-body
    :show-close="false"
    center
    top="8vh"
  >
    <dialog-header
      slot="title"
      :title="$t('statistical.boxAddTask.selectParameters')"
      @close="closeDialog"
    />
    <vue-linetitle>
      <el-form style="width:30vw" :label-position="'right'" label-width="110px">
        <el-form-item :label="$t('statistical.boxAddTask.parameters.parameterName')+'：'">
          <el-input v-model="filterText" style="width:220px" :placeholder="$t('statistical.boxAddTask.parameters.parameterName')" clearable />
        </el-form-item>
      </el-form>
      <div style="height:60vh">
        <el-scrollbar style="height:100%" wrap-class="default-scrollbar__wrap">
          <el-tree
            ref="tree"
            :data="treeData"
            show-checkbox
            :expand-on-click-node="false"
            node-key="id"
            :filter-node-method="filterNode"
            default-expand-all
            :indent="10"
          />
        </el-scrollbar>
      </div>
    </vue-linetitle>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-cancel" type="primary" @click="handleCancel">{{ $t('public.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('public.define') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
let id = 1000
import { getChooseDbcVariables } from '@/api/vehicletravel/downloadData'
export default {
  name: 'ResultDialog',
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    defaultParams: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      treeData: [],
      filterText: ''
    }
  },
  computed: {

  },
  watch: {
    visibles(e1) {
      if (e1) {
        const postData = { terminalcode: this.data[0].terminalcode }
        this.getData(postData)
      }
    },
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    // 关闭dialog
    closeDialog() {
      this.$emit('update:visibles', false)
    },
    getData(postData) {
      getChooseDbcVariables(postData).then(({ data }) => {
        if (data.code === 0) {
          const arr = []
          const obj = {}
          const result = data.data || []
          if (result.length > 0) {
            for (let i = 0; i < result.length; i++) {
              if (result[i].hasOwnProperty('dbcfilename')) {
                arr[0].label = result[i].dbcfilename
                arr[0].id = 'custom' + (++id)
              } else {
                const ai = result[i]
                if (!obj[ai.modulename]) {
                  if (!arr[0]) {
                    arr[0] = {}
                    arr[0].children = []
                  }
                  const o = { label: ai.varname, id: ai.serial, s: ai.modulename }
                  arr[0].children.push({
                    label: ai.modulename,
                    id: 'custom' + (++id),
                    children: [o]
                  })
                  obj[ai.modulename] = o
                } else {
                  for (var j = 0; j < arr[0].children.length; j++) {
                    var dj = arr[0].children[j]
                    if (dj.label == ai.modulename) {
                      const o = { label: ai.varname, id: ai.serial, s: ai.modulename }
                      dj.children.push(o)
                      break
                    }
                  }
                }
              }
            }
          }
          this.treeData = arr
          this.defaultParams.length > 0 && this.$refs.tree.setCheckedKeys(this.defaultParams)
        }
      })
    },
    // 取消
    handleCancel() {
      this.closeDialog()
    },
    handleSubmit() {
      const idList = this.$refs.tree.getCheckedKeys(true)
      const itemList = this.$refs.tree.getCheckedNodes(true)
      this.$emit('selcet-complete', { idList, itemList })
      this.closeDialog()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
